import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

/**
 * @description Error when invalid control is dirty, touched, or submitted
 * @link https://v14.material.angular.io/components/input/examples#input-error-state-matcher
 * @example
 * // Component HTML
 * [errorStateMatcher]="formMatcher"
 * @example
 * // Component Typescript
 * formMatcher = new R1ErrorMatcher();
 */
export class R1ErrorMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}
